'use client'

import MainSlider, {
  type MainSliderAccent,
  type MainSliderNews,
  type MainSliderSize,
} from '@/components/MainSlider'

interface MainSliderClientProps {
  news: MainSliderNews[]
  size?: MainSliderSize
  accent?: MainSliderAccent
  accentColor?: string | null
  className?: string
  lcpPriority?: boolean
}

/** Swiper client boundary — görseller sunucuda çözümlenir, SSR korunur */
export default function MainSliderClient({
  news,
  size = 'main',
  accent = 'red',
  accentColor,
  className = '',
  lcpPriority = false,
}: MainSliderClientProps) {
  return (
    <MainSlider
      news={news}
      size={size}
      accent={accent}
      accentColor={accentColor}
      pagination="bars"
      lcpPriority={lcpPriority}
      className={className}
    />
  )
}
